import { DataTableColumn } from '../DataTable.types';

/**
 * The columns DataTableFilterDrawer will actually render a filter card for.
 *
 * A column is filterable only with BOTH `filterConfig.enabled` and a `filterConfig.filterType`
 * — a config missing either produces no card. This is the single definition of "filterable":
 * the drawer derives its cards from it, and callers gate their filter button on it, so the
 * button can never open a drawer with nothing in it.
 */
export function getFilterableColumns(columns: DataTableColumn[] | undefined | null): DataTableColumn[] {
    return (columns ?? []).filter((column) => column.filterConfig?.enabled && column.filterConfig?.filterType);
}

/**
 * Whether a column set has anything to filter on — the condition for showing a filter button.
 *
 * Columns are config-driven (polus ViewConfig), so a table whose config seeds no filterable
 * column, or whose config hasn't loaded yet, must not offer the control at all.
 */
export function hasFilterableColumns(columns: DataTableColumn[] | undefined | null): boolean {
    return getFilterableColumns(columns).length > 0;
}
